// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uoIjD","content":"styles_content__24_0H","row":"styles_row__1Bk3b","footer":"styles_footer__1gW4o","phraseLength":"styles_phraseLength__1kIvW"};